import { Component } from "react";
import GeneralService from "./GeneralService";
import { Sentinel } from "../model_gen/sentinel";
import { ChatCompletionRequest } from "../model_gen/chat";

export class EvaluationService extends Component {
  public static runOneOffEvaluation(
    chatRequest: ChatCompletionRequest,
    sentinels: Sentinel[],
    loadingHandler: any,
    apiKey: string
  ) {
    const payload = {
      request: chatRequest,
      sentinels: sentinels,
    };
    return GeneralService.post(
      "/evaluation/oneoff",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getEvaluationRequestUrls(
    evaluationRequestId: string,
    sentinelId: string,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/evaluation/requests/${evaluationRequestId}/sentinel/${sentinelId}/urls`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getEvaluationRequests(
    applicationId: string,
    sessionId: string,
    requestId: string,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/evaluation/requests/${applicationId}/${encodeURIComponent(
        sessionId
      )}/${requestId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static runBatchEvaluation(
    payload: any,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      "/evaluation/runs",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getEvaluationRuns(loadingHandler: any, apiKey: string) {
    return GeneralService.get(
      "/evaluation/runs",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getEvaluationRunInfo(
    payload: any,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      "/evaluation/runs/info",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getEvaluationRun(
    evaluationRunId: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/evaluation/runs/${evaluationRunId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getEvaluationRunRequests(
    evaluationRunId: number,
    offset: number,
    limit: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/evaluation/runs/${evaluationRunId}/requests/${offset}/${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getAllEvaluationResults(
    offset: number,
    limit: number,
    filters: { key: string; value: string | number }[],
    loadingHandler: any,
    apiKey: string
  ) {
    const params = new URLSearchParams();

    // Convert filters to query parameters
    filters.forEach((filter) => {
      switch (filter.key) {
        case "status":
          params.append("status", filter.value.toString());
          break;
        case "application":
          params.append("application_id", filter.value.toString());
          break;
        case "intent":
          params.append("intent_id", filter.value.toString());
          break;
        case "intent_group":
          params.append("intent_group_id", filter.value.toString());
          break;
        case "sentinel":
          // Send sentinel filters as combined sentinel_filter parameters
          const sentinelValue = filter.value.toString();
          if (sentinelValue.includes(":")) {
            // Already in the format "id:status"
            params.append("sentinel_filter", sentinelValue);
          } else {
            // Old format, add "ANY" status
            params.append("sentinel_filter", `${sentinelValue}:ANY`);
          }
          break;
      }
    });

    const queryString = params.toString();
    const url = `/evaluation/results/${offset}/${limit}${
      queryString ? "?" + queryString : ""
    }`;

    return GeneralService.get(
      url,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
